import { render, staticRenderFns } from "./PlafondDriverActivities.vue?vue&type=template&id=1838fc26&scoped=true"
import script from "./PlafondDriverActivities.vue?vue&type=script&lang=js"
export * from "./PlafondDriverActivities.vue?vue&type=script&lang=js"
import style0 from "./PlafondDriverActivities.vue?vue&type=style&index=0&id=1838fc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838fc26",
  null
  
)

export default component.exports